/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { getExpenseList, getExpenseDownloadExcel, getExpenseOptionsList } from "../../../apis/expense";
import PageHeader from "../../../components/PageHeader";
import { getParams, getExcelDownParams } from "../../../utils/params";
import { get } from "lodash-es";
import { ControlTable } from "../../../components/Table";
import Filters from "../../../components/Filters";
import { dateToFormat, dateToViewFormat, getDay } from "../../../utils/date";
import { onLoadMultiImage } from "../../../utils/image";
import {
  PAYMENT_TYPE,
  APPR_STATUS,
  EXPENSE_SEARCH_LIST,
} from "../../../constants/EXPENSE";
import { isEmpty } from "lodash";
import { taskDetail, taskRequest } from "../../../utils/task";
import useForm from "../../../hooks/useForm";
import { useSelector } from "react-redux";
import { preventEvent } from "../../../utils/element";
import { TASK_STATUS_LIST } from "../../../constants/TASK";
import DataComponent from "../../../components/DataComponent";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";

import { cloneDeep, isArray } from "lodash-es";
import { downExcelFile } from "../../../utils/download";

import { transformComma } from "../../../utils/validator/comma";
import Profile from "../../../components/Profile";

import ExpenseOption from "./ExpenseOption";
import { viewLoading } from "../../../utils/loading";
import { getFinanacesScrapingHistoryAllList, scrapingFinanacesAll } from "../../../apis/finances/auth";
import systemAlert from "../../../utils/systemAlert";

const ExpenseClaimList = (props) => {
  const history = useHistory();
  const { role, permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
      role: store.Profile.role,
    }),
  );
  const [open, setOpen] = useState(false);
  const [filters, setFilters] = useState([]);
  const [resultRow, setResultRow] = useState({});
  const [expenseOptions, setExpenseOptions] = useState([]);


  const [fields] = useState([
    {
      title: "작성일시",
      key: "createdTime",
      onValue: (value) => {
        return (
          !isEmpty(value) ? (
            <div className="list-date-wrap">
              <p className="list-date">{dateToViewFormat(value)}
                <span className="list-date-time">&nbsp;&nbsp;{dateToViewFormat(value, "HH:mm")}</span>
              </p>
            </div>
          ) : (<>합계</>)
        );
      },
    },
    {
      title: "사용일",
      key: "expenseItems[0].useTime",
      onValue: (value) => {
        return (
          !isEmpty(value) ? (
            <div className="list-date-wrap">
              <p className="list-date">{dateToViewFormat(value)}</p>
            </div>
          ) : (<>-</>)
        );
      },
    },
    {
      title: "영수증이미지",
      key: "expenseItems",
      onValue: (_v, _f, data) => {
        const billFiles = data.expenseItems && data?.expenseItems[0]?.billFiles;

        return (
          <>
            {isEmpty(billFiles)
              ? <>-</>
              : billFiles.map((bill, idx) => (
                <div
                  key={idx}
                  className="bill-img-wrap"
                  onClick={(e) => {
                    preventEvent(e);
                    //handleOnClick(bill)
                    handleOnClick(billFiles, idx);
                  }}
                >
                  <img src={bill.fileUrl} alt={bill.originalName} />
                </div>
              ))
            }
          </>
        );
      },
    },
    {
      title: "작성자",
      key: "reqEmployeeIdx",
      //type: "profile",
      className: "expense-list-user-profile",
      onValue: (value, field, data) => {
        if (!isEmpty(data.reqEmployee)) {
          return (<Profile data={data.reqEmployee}></Profile>);
        } else {
          return (<>-</>);
        }
      }
    },
    {
      title: "지불방법",
      key: "payType",
      onTranslator: {
        list: PAYMENT_TYPE,
      },
    },
    //{ title: "합계금액", key: "expenseItems[0].useAmt", type: "comma" },
    {
      title: "합계금액",
      key: "expenseItems[0].useAmt",
      onValue: (value, field, data) => {
        if (!isEmpty(data.sum)) {
          return (<>{transformComma(data.sum)}</>);
        } else {
          return (<>{transformComma(data.expenseItems[0].useAmt)}</>);
        }
      },
    },
    { title: "비용항목", key: "expenseOptionName" },
    {
      title: "결재상태",
      key: "apprStatus",
      onValue: (value) => {
        if (isEmpty(value)) {
          return (<>-</>);
        } else {
          const target = TASK_STATUS_LIST.find(
            (vacation) => vacation.status === value
          );
          return (
            <DataComponent
              field={{
                type: "badge",
                color: target.color,
                label: target.label,
              }}
            />
          );
        }
      },
    },
  ]);
  const [targetPermission, setTargetPermission] = useState(null);
  const [scrapingPermission, setScrapingPermission] = useState(null);



  const [reload, setReload] = useState(false);
  const [isScraping, setIsScraping] = useState(false);
  const [timerValue, setTimerValue] = useState(0);

  const timerId = useRef(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'EXPENSE');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "EXPENSE");
      }
      const scrapingPermission = permissions.find(p => p.code === 'FINANCE_SCRAPING');
      setScrapingPermission(scrapingPermission);
    }
  }, [permissions]);


  // 스크래핑 관련

  useEffect(() => {
    if (!isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      getHistories();
    }
  }, [scrapingPermission]);

  useEffect(() => {
    timerId.current = setInterval(() => {
      setTimerValue(1);
    }, 1000 * 5);
    return () => clearInterval(timerId.current);
  }, []);


  useEffect(() => {
    if (timerValue === 1 && !isEmpty(scrapingPermission) && scrapingPermission.level > 1) {
      setTimerValue(0);
      if (reload) {
        getHistories();
      }
    }
  }, [timerValue]);

  const getHistories = () => {
    getFinanacesScrapingHistoryAllList({
      limit: 10,
      offset: 0,
      search: { state: 9 },
      order: [{ idx: "desc" }]
    }).then(res => {
      const histories = (res?.data?.histories || [])
        .filter(f => f?.orgCd === "card" || f?.orgCd === "ccd");
      if (!isEmpty(histories)) {
        setReload(true);
        setIsScraping(true);
      } else {
        setReload(false);
        setIsScraping(false);
      }
    });
  };


  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    setInForm,
    // LIST 용
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      range: {
        createdTime: [getDay(7), getDay()]
      },
      page: 0,
      limit: 10,
      requestEmployees: []
    }
  );

  useEffect(() => {
    setFilters([
      {
        title: "작성일시",
        key: "range.createdTime",
        type: "customdatepicker",
      },
      {
        title: "선택한 항목만 보기",
        key: "check",
        type: "checkboxes",
        className: "margin-right-16",
        onChange: (checked, key) => {
          setInForm(key, checked);
        },
        options: {
          list: EXPENSE_SEARCH_LIST,
        },
      },
      {
        title: "결재상태",
        type: "select",
        key: "apprGranted",
        defaultValue: '',
        options: {
          list: [
            { label: "전체", value: '' },
            ...APPR_STATUS
          ]
        },
      },
      {
        title: "비용항목",
        type: "select",
        key: "expenseOptionName", // key: "expenseOptionIdx",
        defaultValue: '',
        options: {
          list: async () => {
            return [
              { label: "전체", value: '' },
              ...expenseOptions.map(d => ({
                label: d.name,
                //value: d.idx
                value: d.name,
              }))
            ];
          }
        },
      },
      {
        title: '작성자',
        type: 'searchEmployees',
        key: 'requestEmployees',
      },
    ]);
  }, [form, expenseOptions]);

  useEffect(() => {
    submit(form);
    setSubmit(submit);
    getExpenseOptionsList().then(res => {
      setExpenseOptions(res);
    });
  }, []);

  const setParams = (params) => {

    const _params = cloneDeep(params);
    if (isArray(_params.requestEmployees)) {
      _params.requestEmployees = _params.requestEmployees.map(e => e.idx);
    }
    if (isEmpty(_params.requestEmployees)) {
      _params.requestEmployees = undefined;
    }
    return { _params };
  };

  const submit = (params) => {
    setIsLoading(true);

    const { _params } = setParams(params);

    getExpenseList({
      ...getParams(_params)
    })
      .then((res) => {
        setList(get(res, "data.expenses"));
        setTotal(get(res, "data.totalCount"));
        const sum = get(res, "data.sum");
        setResultRow({
          //createdTime: '합계',
          sum: sum.sum,
        });

      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  const handleOnClick = (files, selected) => {

    onLoadMultiImage(files, selected);
  };

  const headerButtons = [
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        setIsLoading(true);

        const { _params, checked } = setParams(form);

        getExpenseDownloadExcel({
          ...getExcelDownParams(_params),
          ...checked
        })
          .then((res) => {
            setIsLoading(false);
            downExcelFile(res, "경비청구내역.xlsx");
          });
      },
    },
    {
      isHide: (targetPermission && targetPermission.level <= 1) ||
        !(role && (role?.type === 0 || role?.type === 1 || role?.type === 2 || role?.type === 5)),
      label: "등록하기",
      action: () => {
        taskRequest('expense_request', {});
      },
    },
    {
      isHide: isEmpty(targetPermission) || targetPermission.level <= 1,
      label: "비용항목 관리",
      action: () => {
        setOpen(true);
      },
    },

    {
      isHide: isEmpty(scrapingPermission) || scrapingPermission.level <= 1,
      label: "카드 거래내역 스크래핑",
      disabled: isScraping,
      action: () => {
        systemAlert("수동 스크래핑을 진행하시겠습니까?", {
          buttons: [
            {
              label: "취소",
              color: "text"
            },
            {
              label: "확인",
              onClick: () => {
                const params = {
                  sdate: dateToFormat(new Date(), 'YYYYMMDD'),
                  edate: dateToFormat(new Date(), 'YYYYMMDD'),
                  detailType: [
                    "card",
                    // "bk"
                  ],
                };
                viewLoading(true);
                systemAlert();
                scrapingFinanacesAll(params)
                  .then(() => {
                    setReload(true);
                    setIsScraping(true);
                    systemAlert(
                      <>
                        <p>스크래핑 요청에 성공하였습니다.</p>
                        <p>스크래핑이 완료될 때까지 일정시간이 소요됩니다.</p>
                        <p className="color-red-100">수집이력 내역 반영까지 일정시간이 소요됩니다.</p>
                        <p> 관리자 -&gt; 금융정보 자동 수집 -&gt; 수집이력에서</p>
                        <p>스크래핑 결과를 확인하실 수 있습니다.</p>
                      </>
                      , {
                        buttons: [
                          {
                            label: "수집이력 확인하기",
                            onClick: () => {
                              history.push("/manager/financial?tab=scraping-history");
                            }
                          },
                          {
                            label: "확인",
                            onClick: () => {
                              getHistories();
                            }
                          },
                        ]
                      });

                  })
                  .finally(() => {
                    viewLoading(false);
                  });
              }
            }
          ]
        });
      }
    },
  ];

  const openTaskDetail = (data, e) => {
    taskDetail({
      type: "expense_request",
      targetWorkIdx: data.idx,
    });
  };

  return (
    !isEmpty(targetPermission) && (
      <div className="expense-list">
        <PageHeader title={"경비 청구 내역"} buttons={headerButtons} />
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isLoading={isLoading}
          fields={fields}
          list={list}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          total={total}
          submit={handleSubmit}
          onSelect={openTaskDetail}
          resultRow={resultRow}
        />
        <ExpenseOption
          open={open}
          setOpen={setOpen}
        //submit={filterSubmit}
        />
      </div>
    ));
};

export default ExpenseClaimList;
